import React from 'react';

const AdminRoute = () => {
    return (
        <div>
            <h1>I am an Admin</h1>
        </div>
    );
};

export default AdminRoute;

